import React, { useEffect, useState } from 'react';
import { TouchableOpacity } from 'react-native';
import { ThemedView, ThemedText, Theme } from '@app/theme';
import BottomSheetContainer from '@app/sharedComponents/Bottomsheet/Bottomsheet';
import { TextAlignTokens } from '@voltmoney/schema';
import Button from '@app/sharedComponents/Button/Button';
import gs from '../../../styles/globalStyles';
import ProgressBar from '@app/sharedComponents/ProgressBar/ProgressBar';
import { FetchPortfolioModalType } from '../type';
import SystemWarning from '../../../../assets/Icons/SystemWarning';
import { useTheme } from '@shopify/restyle';

export interface FetchPortfolioModalProps {
    title?: string;
    subtitle?: string;
    primaryCtaTitle?: string;
    tertiaryCTATitle?: string;
    primaryCtaAction?: () => void;
    tertiaryCTAAction?: () => void;
    visible?: boolean;
    type?: FetchPortfolioModalType;
    loadingTime?: number;
    onModalClose?: () => void;
    loaderText?: string;
}

const FetchPortfolioModals: React.FC<FetchPortfolioModalProps> = ({
    title,
    subtitle,
    primaryCtaTitle,
    tertiaryCTATitle,
    primaryCtaAction,
    tertiaryCTAAction,
    visible = false,
    type = FetchPortfolioModalType.IMMEDIATE,
    loadingTime,
    onModalClose,
    loaderText
}) => {
    const [_show, setShowModal] = useState(false);
    const {colors} = useTheme<Theme>()

    useEffect(() => {
        if (title === null || title === undefined || title === 'null') {
            setShowModal(false);
        } else {
            setShowModal(visible);
        }
    }, [visible, title]);

    return (
        <BottomSheetContainer
            isVisible={visible}
            showCloseIcon={type !== FetchPortfolioModalType.LOADER}
            onClose={() => {
                setShowModal(false);
                onModalClose && onModalClose();
            }}
            closeOnBackdropPress={false}
            borderTopRightRadius={10}
            borderTopLeftRadius={10}
            containerStyle={gs.setBg('#fefefe')}
            close={() => {
                setShowModal(false);
                onModalClose && onModalClose();
            }}
            dragComponent={null}
        >
            <ThemedView
                style={{
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    padding: 16, 
                    width: '100%',
                }}>
                <ThemedView style={[gs.flexRow, gs.justifyCenter, {marginTop: 8}]} >
                    {/* <Icon name="SYSTEM_STATUS_WARNING_DLS" size="XXXXXXXL" /> */}
                    <SystemWarning size={48} />
                </ThemedView>

                {title && title !== null && title !== 'null' && (
                    <>
                        <ThemedView style={[gs.setMarginTop(24)]}/>
                        <ThemedText
                            variant='h5s'
                            color="text-primary"
                            textAlign={TextAlignTokens.center}
                        >
                            {title}
                        </ThemedText>
                    </>
                )}

                {type !== FetchPortfolioModalType.LOADER && subtitle && subtitle !== null && subtitle !== 'null' && (
                    <>
                        <ThemedView style={[gs.setMarginTop(8)]}/>
                        <ThemedView 
                            style={{
                                    width: '100%',
                            }}
                        >
                            <ThemedText
                                variant='b3r'
                                color="text-primary"
                                style={{
                                    backgroundColor: '#FFFAE9',
                                    padding: 12,
                                    borderRadius: 8,
                                    width: '100%',
                                    textAlign: 'center',
                                }}
                            >
                                {subtitle}
                            </ThemedText>
                        </ThemedView>
                    </>
                )}

                {type !== FetchPortfolioModalType.LOADER && primaryCtaAction && primaryCtaTitle && (
                    <>
                        <ThemedView style={[gs.setMarginTop(24)]}/>
                        <Button
                            type="SOLID"
                            size="MD"
                            label={primaryCtaTitle || 'Test'}
                            bg="bg-action-primary"
                            textColor="text-on-action-primary"
                            handlePress={() => {
                                primaryCtaAction &&
                                primaryCtaAction();
                            }}
                        />
                    </>
                )}

                {type !== FetchPortfolioModalType.LOADER && tertiaryCTATitle && tertiaryCTAAction && (
                    <ThemedView style={{width: '100%', marginTop: primaryCtaAction && primaryCtaTitle ? 12 : 24}}>
                        <Button
                            type='OUTLINED'
                            size="MD"
                            label={tertiaryCTATitle || 'Test'}
                            bg="bg-action-primary"
                            textColor="text-on-action-primary"
                            handlePress={() => {
                                tertiaryCTAAction &&
                                tertiaryCTAAction();
                            }}
                        />
                    </ThemedView>
                )}

                {type === FetchPortfolioModalType.LOADER && (
                    <>
                        <ThemedView style={[gs.setMarginTop(24)]}/>
                        {loaderText && (
                            <ThemedView style={[gs.setPaddingBottom(8)]}>
                                <ThemedText
                                    variant='b4m'
                                    color="text-primary"
                                    // textAlign={TextAlignTokens.center}
                                >
                                    {loaderText}
                                </ThemedText>
                            </ThemedView>
                        )}
                        <ProgressBar
                            color={colors['bg-action-primary']}
                            unfilledColor={colors['bg-fill-emphasis-primary-1']}
                            loadingTime={loadingTime}
                        />
                    </>
                )}
            </ThemedView>
        </BottomSheetContainer>
    );
};

export default FetchPortfolioModals; 